import cookies from 'browser-cookies';
import getParameterByName from './utils/url';
import { getWindow, whenOlarkExists } from './utils/dom-utils';

export function olarkSetRid(providedRid) {
  const existingRid = cookies.get('rid');
  const ridParam = getParameterByName('rid');

  /*
   * If we have an existing rid cookie, leave as is.
   * Otherwise, if we have a rid url param, set the rid cookie with the param.
   * Otherwise, if we have a provided rid, set the rid cookie with the provided rid.
   */
  if (!existingRid) {
    if (ridParam || providedRid) {
      cookies.set('rid', ridParam || providedRid, { expires: 64, path: '/', samesite: 'Strict' });
    }
  }

  /*
   * If a rid was provided, pass it to analytics.
   * Analytics and ga are injected via the segment snippet in the header.
   */
  if (providedRid) {
    analytics.track('Visit with referral id', { 'rid': providedRid });
    ga && ga('set', 'campaignId', providedRid);
  }
}

export function olarkSetReferrer(current_referrer) {
  // initialize Google Tracker in here

  const referrer = cookies.get('olark_referrer');

  if (!referrer) {

    if (getParameterByName("rid") && getParameterByName("rid") !== '') {

      const campaign = getParameterByName('utm_campaign');
      current_referrer = "widget:" + getParameterByName("rid") + "/" + getParameterByName("premium") + "/" + document.referrer;

      if (campaign === 'new_branding') {
        current_referrer += ("/popup_branding/" + getParameterByName('lid'));
      } else if(campaign) {
        current_referrer += ("/" + campaign);
      }

    } else if (!current_referrer) {
      current_referrer = "(Direct)";
    }

    cookies.set('olark_referrer', current_referrer, { expires: 64 , path:'/', samesite: 'Strict'});
  } // end referrer

}

export default function initReferrers() {
  whenOlarkExists(() => {
    olarkSetReferrer(getWindow().document.referrer);
    olarkSetRid(getParameterByName('rid') || getParameterByName('mbsy'));
  })
}
